<style lang="less" scoped>
  .order-list {
    min-height: 100vh;
    .order-code {
      position: relative;
      height: 88rpx;
      margin: 30rpx;
      background: #fff;
      border-radius: 44rpx;
    }
    .search-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      color: #999;
      border-radius: 30rpx;
      ._icon {
        margin-right: 10rpx;
      }
    }
    .search-input {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      padding: 15rpx 30rpx;
      border: 0;
      outline: 0;
      background: transparent;
      border-radius: 44rpx;
      box-sizing: border-box;
      text-align: center;
      color: #333;
      box-shadow: none;
      transition: box-shadow 0.2s ease;
      &:focus {
        box-shadow: inset 0 0 1px 1px #3473f6;
      }
    }
    .list-content {
      padding-left: 15rpx;
      padding-right: 15rpx;
      margin: 0 15rpx;
      .no-more {
        text-align: center;
        line-height: 2em;
        font-size: 14px;
        color: #999;
        box-sizing: border-box;
      }
    }
    .content-item {
      padding: 30rpx 16rpx 50rpx 30rpx;
      border-radius: 20rpx;
      background: #fff;
      margin-bottom: 10rpx;
      overflow: hidden;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .content-item-above {
      display: flex;
      align-items: center;
      font-weight: 500;
      color: #333;
      .above-icon {
        width: 40rpx;
        height: 40rpx;
        margin-right: 20rpx;
      }
      .above-store {
        flex: 1;
      }
      .above-price {
        color: #ff5859;
      }
      .above-unit {
        font-size: 0.8rem;
      }
    }
    .content-item-under {
      display: flex;
      align-items: center;
      margin-top: 30rpx;
      .under-info {
        flex: 1;
        color: #999;
      }
      .under-number {
        margin-bottom: 20rpx;
      }
      .under-time {
        display: flex;
        align-items: center;
      }
      .under-icon {
        width: 24rpx;
        height: 24rpx;
        margin-right: 12rpx;
      }
      .under-btn {
        min-width: 130rpx;
        height: 50rpx;
        padding: 0 18rpx;
        color: #488ef8;
        border: 1px solid #488ef8;
        border-radius: 50rpx;
        background: #fff;
        outline: none;
        transition: opacity 0.2s ease;
        user-select: none;
        &.red-btn {
          color: @DefaultColor;
          border: 1px solid @DefaultColor;
        }
        &:active {
          opacity: 0.5;
        }
      }
    }
  }
</style>
<template>
  <van-pull-refresh v-model="loading"
                    @refresh="searchorderListFn"
                    class="order-list">
    <form class="order-code"
          action=""
          @submit.prevent="searchorderListFn">
      <div v-if="placeholderShow"
           class="search-icon">
        <van-icon class="_icon"
                  name="search" />
        <span>请输入订单号</span>
      </div>
      <input v-model="searchCode"
             name="code"
             class="search-input"
             type="text"
             placeholder="">
    </form>

    <div class="list-content"
         v-if="orderList.length">
      <div class="content-item"
           v-for="(order, orderIndex) in orderList"
           @click="orderClickEvent('/order-product',order)"
           :key="orderIndex">
        <div class="content-item-above">
          <img class="above-icon"
               src="~@/assets/icon_warranty_order_list_store.png">
          <span class="above-store">商家：{{ order.tenantName }}</span>
          <div v-if="sysConstConfig.showBuyPrice === 'orderPrice'"
               class="above-price">
            <span class="above-unit">¥</span>
            <span>{{ order.orderPrice || 0 }}</span>
          </div>
          <div v-if="sysConstConfig.showBuyPrice === 'realPrice'"
               class="above-price">
            <span class="above-unit">¥</span>
            <span>{{ order.realPrice || 0 }}</span>
          </div>
        </div>

        <div class="content-item-under">
          <div class="under-info">
            <div class="under-number">订单号：{{ order.orderCode }}</div>
            <div class="under-time">
              <img class="under-icon"
                   src="~@/assets/icon_warranty_order_list_time.png">
              <span>{{ order.createTime | dateFormat }}</span>
            </div>
          </div>
          <button v-if="order.storeOrderEvaluateBase"
                  @click.stop="orderClickEvent('/evaluate-detail',order)"
                  class="under-btn red-btn">查看评价</button>
          <button v-else
                  @click.stop="orderClickEvent('/evaluate',order)"
                  class="under-btn">评价</button>
        </div>
      </div>

      <div class="no-more">没有更多了~</div>
      <div class="safe-area-bottom"></div>
    </div>

    <div class="list-content"
         v-else>
      <van-empty  :image="`${sysConstConfig.webPath}/platform-assets/common/icon_empty.png`"
                 description="订单未查到" />
    </div>
  </van-pull-refresh>
</template>
<script>
  import { queryOrderWarranty } from '@/config/api.js'
  import moment from 'moment'

  export default {
    name: 'WarrantyOrders',
    filters: {
      dateFormat (val) {
        if (!val) { return '-' }
        return moment(val).format('YYYY/MM/DD HH:mm:ss')
      }
    },
    data () {
      return {
        tenantId: '',
        searchCode: '',
        orderList: [],
        loading: false
      }
    },
    computed: {
      placeholderShow () {
        return this.searchCode.replace(/\s/g, '') === ''
      }
    },
    methods: {
      searchorderListFn () {
        if (!this.searchCode) {
          this.$toast('请输入内容')
          return false
        }
        this.loading = true
        queryOrderWarranty({
          keywords: this.searchCode,
          tenantId: this.tenantId
        }).then(res => {
          this.loading = false
          if (res.success) {
            this.orderList = res.result || []
          }
        })
      },
      orderClickEvent (type, data) {
        this.$router.push({
          path: type,
          query: {
            id: data.id,
            usr: this.tenantId,
            key: data.orderCode,
            store: data.tenantName
          }
        })
      }
    },
    mounted () {
      this.tenantId = this.$route.query.usr || ''
      this.searchCode = this.$route.query.key || ''
      this.searchorderListFn()
    }
  }
</script>